import { notifications } from '@mantine/notifications';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { addDoc, collection, doc, getDocs, onSnapshot, query, setDoc, updateDoc, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import Avaliacoes from './componentes/Avaliacoes/Avaliacoes';
import Banner from './componentes/Banner/Banner';
import Barbeiros from './componentes/Barbeiros/Barbeiros';
import BarraNavegacao from './componentes/BarraNavegacao/BarraNavegacao';
import Contato from './componentes/Contato/Contato';
import Localizacao from './componentes/Localizacao/Localizacao';
import './index.css';
import Acesso from './pages/Acesso/Acesso';
import AgendamentoDataHora from './pages/Agendamento/AgendamentoDataHora';
import AgendamentoServico from './pages/Agendamento/AgendamentoServico';
import SucessoAgendamento from './pages/Agendamento/Sucesso/SucessoAgendamento';
import PainelConfiguracoes from './pages/PainelControle/ConfiguracoesPerfil/ConfiguracoesPerfil';
import HistoricoUsuario from './pages/PainelControle/HistoricoUsuario/HistoricoUsuario';
import PainelDono from './pages/PainelControle/PainelDono/PainelDono';
import PainelMaster from './pages/PainelControle/PainelMaster/PainelMaster';
import PaginaVendas from './pages/PlanoSaaS/PaginaVendas';
import RegistroNegocio from './pages/PlanoSaaS/RegistroNegocio';
import { auth, db } from './servicos/firebase';
import { seedDatabase } from './utilitarios/seed';

// Utilitário para converter strings de duração (ex: "1h 15min") em minutos
const parseDuration = (durationStr) => {
  if (!durationStr) return 60;
  let totalMinutes = 0;
  const hoursMatch = durationStr.match(/(\d+)\s*h/);
  const minsMatch = durationStr.match(/(\d+)\s*min/);

  if (hoursMatch) totalMinutes += parseInt(hoursMatch[1]) * 60;
  if (minsMatch) totalMinutes += parseInt(minsMatch[1]);

  // Se não encontrar nem h nem min mas houver um número, assume minutos (ou 60 se zero)
  if (totalMinutes === 0) {
    const numMatch = durationStr.match(/(\d+)/);
    totalMinutes = numMatch ? parseInt(numMatch[1]) : 60;
  }

  return totalMinutes;
};

function App() {
  const [user, setUser] = useState(null); // { uid, name, email, whatsapp, isAdmin, isMaster }
  const [showLogin, setShowLogin] = useState(false);
  const [bookingStep, setBookingStep] = useState('home');
  const [isRegisteringBusiness, setIsRegisteringBusiness] = useState(false);
  const [selectedBarber, setSelectedBarber] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [userAppointments, setUserAppointments] = useState([]);
  const [barbers, setBarbers] = useState([]);
  const [services, setServices] = useState([]);
  const [blockedTimes, setBlockedTimes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isBarbersLoaded, setIsBarbersLoaded] = useState(false);
  const [isServicesLoaded, setIsServicesLoaded] = useState(false);
  const [dbStatus, setDbStatus] = useState('Conectando...');
  const [dbError, setDbError] = useState(null);
  const [confirmedBooking, setConfirmedBooking] = useState(null);
  const [systemBlocks, setSystemBlocks] = useState([]);
  const [currentTenant, setCurrentTenant] = useState(null);
  const [tenantConfig, setTenantConfig] = useState(null);
  const [masterBypass, setMasterBypass] = useState(false);
  const [loginMode, setLoginMode] = useState('login');
  const [globalBroadcast, setGlobalBroadcast] = useState(null);
  const [reschedulingAppId, setReschedulingAppId] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);


  const handleStartRegistration = (planId) => {
    setSelectedPlan(planId);
    setIsRegisteringBusiness(true);
  };

  const mastersList = ['claudio56908@gmail.com'];

  // 1. Detect Tenant Early and Reactively
  useEffect(() => {
    const detectTenant = () => {
      const params = new URLSearchParams(window.location.search);
      const shop = params.get('shop');
      const register = params.get('register');

      console.log("🔗 Detectando tenant da URL:", shop);
      setCurrentTenant(shop);

      if (register === 'business') {
        setIsRegisteringBusiness(true);
      }
    };

    detectTenant();

    // Listen to browser navigation (back/forward or history changes)
    window.addEventListener('popstate', detectTenant);

    // Failsafe: Force stop loading after 4 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 4000);

    return () => {
      window.removeEventListener('popstate', detectTenant);
      clearTimeout(timer);
    };
  }, []);

  // 1.5 Reset Booking State on Tenant Change
  useEffect(() => {
    if (currentTenant) {
      console.log("🔄 Barbearia alterada. Resetando estados de agendamento...");
      setBookingStep('home');
      setSelectedBarber(null);
      setSelectedServices([]);
      setReschedulingAppId(null);
      setConfirmedBooking(null);
    }
  }, [currentTenant]);

  // 2. Auth State Trigger (Mount Only)
  const [firebaseUser, setFirebaseUser] = useState(null);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (fbUser) => {
      setFirebaseUser(fbUser);
      if (!fbUser) {
        setUser(null);
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  // 3. User Profile and Master Status Sync (Depends on Auth)
  useEffect(() => {
    if (!firebaseUser) return;

    const userEmail = firebaseUser.email.toLowerCase();
    const isMaster = mastersList.includes(userEmail);

    // Initial user state before profile loads
    setUser(prev => ({
      uid: firebaseUser.uid,
      name: prev?.name || firebaseUser.displayName || userEmail.split('@')[0],
      email: firebaseUser.email,
      whatsapp: prev?.whatsapp || '',
      isAdmin: isMaster || prev?.isAdmin || false,
      isMaster: isMaster
    }));

    // Listen to profile changes
    const unsubProfile = onSnapshot(doc(db, "users", firebaseUser.uid), async (userDoc) => {
      const data = userDoc.exists() ? userDoc.data() : {};

      // If we are logged in via Google/Email but Firestore record is empty or missing WhatsApp
      // we consider the profile incomplete.
      const hasWhatsapp = !!data.whatsapp;

      // Buscar cargo se for funcionário (procura na coleção barbers)
      let staffRole = null;
      try {
        const qBarber = query(collection(db, "barbers"), where("email", "==", userEmail));
        const snapBarber = await getDocs(qBarber);
        if (!snapBarber.empty) {
          const barberData = snapBarber.docs[0].data();
          staffRole = barberData.role;

          if (!data.barbershopId && barberData.barbershopId) {
            setDoc(doc(db, "users", firebaseUser.uid), {
              barbershopId: barberData.barbershopId,
              role: staffRole
            }, { merge: true }).catch(console.error);
          }
        }
      } catch (err) { }

      setUser(prev => {
        const isMaster = mastersList.includes(userEmail) || prev?.isMaster;
        const currentRole = staffRole || data.role || 'client';

        // Strict Isolation: Admin only if email is in THIS tenant's config OR is master
        // We verify if they are owners of THIS tenant
        const isShopOwner = (currentRole === 'owner' || currentRole === 'admin' || data.isAdmin) &&
          (data.barbershopId === currentTenant || tenantConfig?.adminEmails?.includes(userEmail));

        return {
          ...prev,
          name: data.name || firebaseUser.displayName || userEmail.split('@')[0],
          whatsapp: data.whatsapp || '',
          barbershopId: data.barbershopId || null,
          role: currentRole,
          isAdmin: isMaster || isShopOwner,
          isProfileComplete: hasWhatsapp
        };
      });

      // Lógica de Redirecionamento e Vínculo
      if (!currentTenant) {
        let shopIdToRedirect = data.barbershopId;

        if (!shopIdToRedirect) {
          console.log("🔍 Procurando barbearia por e-mail:", userEmail);
          try {
            const q = query(collection(db, "tenants"), where("adminEmails", "array-contains", userEmail));
            const snap = await getDocs(q);
            if (!snap.empty) {
              shopIdToRedirect = snap.docs[0].id;
            }
          } catch (err) { }
        }

        if (shopIdToRedirect) {
          setCurrentTenant(shopIdToRedirect);
          setBookingStep('dashboard');
          const newUrl = window.location.pathname + `?shop=${shopIdToRedirect}`;
          window.history.pushState({ path: newUrl }, '', newUrl);

          if (!data.barbershopId) {
            setDoc(doc(db, "users", firebaseUser.uid), {
              barbershopId: shopIdToRedirect,
              role: data.role || 'owner'
            }, { merge: true }).catch(console.error);
          }
        }
      } else if (currentTenant && !data.barbershopId && data.role !== 'owner' && data.role !== 'admin') {
        console.log("🔗 Vinculando usuário logado à loja atual:", currentTenant);
        setDoc(doc(db, "users", firebaseUser.uid), {
          barbershopId: currentTenant,
          tenantId: currentTenant
        }, { merge: true }).catch(console.error);
      }

      setLoading(false);
    }, (err) => {
      console.error("Profile sync error:", err);
      setLoading(false);
    });

    // Check for master_config emails in DB as well
    const masterRef = doc(db, "master_config", "admins");
    const unsubMaster = onSnapshot(masterRef, (snap) => {
      if (snap.exists() && snap.data().emails?.includes(userEmail)) {
        setUser(prev => ({ ...prev, isMaster: true, isAdmin: true }));
      }
    }, () => { });

    return () => {
      unsubProfile();
      unsubMaster();
    };
  }, [firebaseUser, currentTenant, tenantConfig]);





  // Derived Values for UI stability during transitions
  const isCurrentlyMaster = user?.isMaster || (firebaseUser && mastersList.includes(firebaseUser.email?.toLowerCase()));

  // 4. Sync Tenant Config (Depends on Tenant ID)
  useEffect(() => {
    if (!currentTenant) return;
    console.log("🏢 Buscando configuração da barbearia:", currentTenant);

    const unsub = onSnapshot(doc(db, "tenants", currentTenant), (snap) => {
      if (snap.exists()) {
        console.log("✅ Configuração da barbearia carregada.");
        const configData = snap.data();
        setTenantConfig(configData);

        // Update isAdmin based on loaded config
        if (firebaseUser) {
          const email = firebaseUser.email.toLowerCase();
          const isShopAdmin = configData.adminEmails?.includes(email);
          const isMaster = mastersList.includes(email) || user?.isMaster;
          setUser(prev => ({ ...prev, isAdmin: isMaster || isShopAdmin || (prev?.role === 'owner' && prev?.barbershopId === currentTenant) }));
        }
      } else {
        setTenantConfig({ name: 'Nova Barbearia', status: 'active', adminEmails: [] });
      }
    }, (error) => {
      console.error("Tenant config error:", error);
    });

    return () => unsub();
  }, [currentTenant, firebaseUser?.uid]);

  // 5. Monitor Connectivity
  useEffect(() => {
    if (!currentTenant) return;

    const unsub = onSnapshot(doc(db, "config", `settings_${currentTenant}`),
      () => setDbStatus('Online'),
      (err) => console.error("Connectivity err:", err.code)
    );
    return () => unsub();
  }, [currentTenant]);

  // 6. Global Broadcast Sync
  useEffect(() => {
    const unsub = onSnapshot(doc(db, "global_config", "broadcast"), (snap) => {
      if (snap.exists() && snap.data().active) {
        setGlobalBroadcast(snap.data());
      } else {
        setGlobalBroadcast(null);
      }
    });
    return () => unsub();
  }, []);

  // 7. AUTO-SEED Logic
  useEffect(() => {
    if (!currentTenant || (!user?.isAdmin && !user?.isMaster)) return;

    const checkAndSeed = async () => {
      try {
        const q = query(collection(db, "barbers"), where("barbershopId", "==", currentTenant));
        const snap = await getDocs(q);
        if (snap.empty) {
          console.log("🌱 Barbearia nova detectada. Semeando dados iniciais...");
          await seedDatabase(currentTenant);
        }
      } catch (err) {
        console.error("Erro no auto-seed:", err);
      }
    };
    checkAndSeed();
  }, [currentTenant, user?.isAdmin, user?.isMaster]);

  // 7. Business Data Sync
  useEffect(() => {
    if (!currentTenant) return;

    const isInactive = tenantConfig && tenantConfig.status !== 'active';
    if (isInactive && !isCurrentlyMaster) {
      console.log("⏸ Sincronização suspensa: Barbearia inativa.");
      return;
    }

    console.log(`🛠 Sincronizando dados para: ${currentTenant}`);

    const qBarbers = query(collection(db, "barbers"), where("barbershopId", "==", currentTenant));
    const barbersUnsubscribe = onSnapshot(qBarbers,
      (snapshot) => {
        setBarbers(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        setIsBarbersLoaded(true);
        setDbError(null);
      },
      (err) => {
        console.error("Barbers sync error:", err);
        setDbStatus('Erro de Permissão (Barbeiros)');
        if (user?.isAdmin || user?.isMaster) {
          setDbError("Acesso Negado: Verifique as Regras do Firebase. (Barbeiros)");
        }
      }
    );

    const qServices = query(collection(db, "services"), where("barbershopId", "==", currentTenant));
    const servicesUnsubscribe = onSnapshot(qServices,
      (snapshot) => {
        setServices(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        setIsServicesLoaded(true);
        setDbError(null);
      },
      (err) => {
        console.error("Services sync error:", err);
        setDbStatus('Erro de Permissão (Serviços)');
        if (user?.isAdmin || user?.isMaster) {
          setDbError("Acesso Negado: Verifique as Regras do Firebase. (Serviços)");
        }
      }
    );

    const qBlocked = query(collection(db, "blockedTimes"), where("barbershopId", "==", currentTenant));
    const blockedUnsubscribe = onSnapshot(qBlocked,
      (snapshot) => {
        setBlockedTimes(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
      },
      (err) => console.log("Blocked times permission sync paused.")
    );

    const qSystemBlocks = query(collection(db, "appointments"),
      where("status", "==", "Sistema_Bloqueado"),
      where("barbershopId", "==", currentTenant)
    );
    const sysBlocksUnsubscribe = onSnapshot(qSystemBlocks,
      (snapshot) => {
        setSystemBlocks(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
      },
      (err) => console.log("System blocks permission sync paused.")
    );

    // Busca geral da loja (para bloquear horários ocupados)
    const qApp = currentTenant ? query(collection(db, "appointments"), where("barbershopId", "==", currentTenant)) : null;

    let appUnsubscribe = () => { };
    if (qApp) {
      appUnsubscribe = onSnapshot(qApp, (snap) => {
        setAppointments(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      }, (err) => {
        console.error("Appointments sync error (Permission issue expected if client):", err);
      });
    }

    // Busca específica do usuário (para o histórico)
    let userAppUnsubscribe = () => { };
    if (user?.uid) {
      const qUserApp = query(collection(db, "appointments"), where("clientId", "==", user.uid));
      userAppUnsubscribe = onSnapshot(qUserApp, (snap) => {
        setUserAppointments(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      }, (err) => console.error("User history sync error:", err));
    }

    return () => {
      barbersUnsubscribe();
      servicesUnsubscribe();
      blockedUnsubscribe();
      sysBlocksUnsubscribe();
      appUnsubscribe();
      userAppUnsubscribe();
    };
  }, [currentTenant, user?.isAdmin, isCurrentlyMaster, tenantConfig?.status]);

  const handleLogin = (loginData) => {
    setShowLogin(false);
    setLoginMode('login');
    if (mastersList.includes(loginData?.email?.toLowerCase())) {
      setBookingStep('master');
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setFirebaseUser(null);
    setUser(null);
    setBookingStep('home');
    setMasterBypass(false);
    setReschedulingAppId(null);
  };

  const handleNavigate = (step) => {
    setBookingStep(step);
    setReschedulingAppId(null);
    window.scrollTo(0, 0);
  };

  const handleSelectBarber = (barber) => {
    setSelectedBarber(barber);
    setBookingStep('service');
    window.scrollTo(0, 0);
  };

  const handleSelectServices = (services) => {
    setSelectedServices(services);
    setBookingStep('datetime');
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    if (bookingStep === 'service') setBookingStep('home');
    if (bookingStep === 'datetime') {
      if (reschedulingAppId) {
        setBookingStep('history');
        setReschedulingAppId(null);
      } else {
        setBookingStep('service');
      }
    }
    if (['history', 'dashboard', 'profile'].includes(bookingStep)) setBookingStep('home');
    window.scrollTo(0, 0);
  };

  const handleConfirmBooking = async (bookingData) => {
    // Bloqueia agendamento se o usuário não estiver logado
    if (!user) {
      setLoginMode('register');
      setShowLogin(true);
      return;
    }

    try {
      const totalPrice = selectedServices.reduce((total, s) => {
        const val = parseFloat(s.price.replace('R$ ', '').replace(',', '.'));
        return total + val;
      }, 0);

      const totalDuration = selectedServices.reduce((total, s) => {
        return total + parseDuration(s.duration);
      }, 0);

      const bookingDataFinal = {
        ...bookingData,
        barber: selectedBarber.name,
        service: selectedServices.map(s => s.name).join(' + '),
        price: `R$ ${totalPrice.toFixed(2).replace('.', ',')}`,
        durationMinutes: totalDuration,
        client: user.name || 'Cliente',
        whatsapp: user.whatsapp || '',
        clientId: user.uid, // Agora o uid sempre existirá devido ao check inicial
        status: reschedulingAppId ? 'Remarcado' : 'Agendado',
        barbershopId: currentTenant,
        tenantId: currentTenant,
        createdAt: new Date().toISOString()
      };

      if (reschedulingAppId) {
        await updateDoc(doc(db, "appointments", reschedulingAppId), bookingDataFinal);
      } else {
        await addDoc(collection(db, "appointments"), bookingDataFinal);
      }

      // Vínculo do usuário com a unidade para aparecer no Painel Master
      try {
        await setDoc(doc(db, "users", user.uid), {
          barbershopId: currentTenant,
          tenantId: currentTenant // Mantendo ambos por retrocompatibilidade
        }, { merge: true });
      } catch (err) {
        console.warn("Não foi possível atualizar vínculo do usuário:", err);
      }

      setConfirmedBooking(bookingDataFinal);
      setBookingStep('success');
      setReschedulingAppId(null);
    } catch (error) {
      notifications.show({
        title: 'Erro no Agendamento',
        message: 'Não foi possível completar o agendamento. Verifique sua conexão.',
        color: 'red',
      });
    }
  };

  const handleUpdateStatus = async (id, newStatus) => {
    try { await updateDoc(doc(db, "appointments", id), { status: newStatus }); } catch (e) { }
  };

  const handleUpdateAppointment = async (id, data) => {
    try { await updateDoc(doc(db, "appointments", id), data); } catch (e) { }
  };

  const handleUpdateProfile = async (profileData) => {
    if (!user?.uid) return;
    await setDoc(doc(db, "users", user.uid), profileData, { merge: true });
  };

  const handleReschedule = (app) => {
    // Encontrar barbeiro e serviços
    const barber = barbers.find(b => b.name === app.barber);
    const serviceNames = app.service.split(' + ');
    const matchedServices = services.filter(s => serviceNames.includes(s.name));

    if (barber && matchedServices.length) {
      setSelectedBarber(barber);
      setSelectedServices(matchedServices);
      setReschedulingAppId(app.id);
      setBookingStep('datetime');
      window.scrollTo(0, 0);
    } else {
      notifications.show({
        title: 'Atenção',
        message: 'Não foi possível carregar os dados originais para remarcação.',
        color: 'orange',
      });
    }
  };

  const lastApp = user && !user.isAdmin ?
    userAppointments
      .filter(app => app.status !== 'Cancelado')
      .sort((a, b) => new Date(b.date + 'T' + b.time) - new Date(a.date + 'T' + a.time))[0]
    : null;

  const handleExpressBooking = () => {
    if (!lastApp) return;
    const barber = barbers.find(b => b.name === lastApp.barber);
    const serviceNames = lastApp.service.split(' + ');
    const matchedServices = services.filter(s => serviceNames.includes(s.name));
    if (barber && matchedServices.length) {
      setSelectedBarber(barber);
      setSelectedServices(matchedServices);
      setBookingStep('datetime');
      window.scrollTo(0, 0);
    }
  };

  if (loading) return <div className="loading-screen">Carregando Barbearia...</div>;

  if (bookingStep === 'master' && isCurrentlyMaster) {
    return <PainelMaster onBack={() => setBookingStep('home')} />;
  }


  const now = new Date();
  const dueDate = tenantConfig?.dueDate ? new Date(tenantConfig.dueDate) : null;
  const isExpired = dueDate && now > dueDate;
  const isSuspended = tenantConfig?.status === 'inactive' || isExpired;

  if (isSuspended && !masterBypass) {
    return (
      <div className="App" style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '20px' }}>
        <div style={{ background: 'rgba(255,255,255,0.03)', padding: '60px 40px', borderRadius: '30px', border: '1px solid rgba(218, 165, 32, 0.2)', maxWidth: '500px', backdropFilter: 'blur(20px)' }}>
          <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⚠️</div>
          <h2 style={{ fontSize: '2rem', color: '#DAA520', marginBottom: '15px', fontWeight: 900 }}>ACESSO BLOQUEADO</h2>
          <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.6, fontSize: '1.2rem', fontWeight: 600 }}>Esta barbearia está suspensa por falta de pagamento ou manutenção.</p>
          {isCurrentlyMaster && (
            <button onClick={() => setMasterBypass(true)} style={{ marginTop: '40px', background: 'rgba(218, 165, 32, 0.1)', border: '1px solid #DAA520', color: '#DAA520', padding: '12px 20px', borderRadius: '10px', cursor: 'pointer', fontWeight: 700, fontSize: '0.8rem', textTransform: 'uppercase' }}>Entrar como Desenvolvedor (Bypass)</button>
          )}
          <div style={{ marginTop: '40px', paddingTop: '30px', borderTop: '1px solid rgba(255,255,255,0.1)' }}><p style={{ fontSize: '0.8rem', opacity: 0.5 }}>Plataforma StartWebb v2.0</p></div>
        </div>
      </div>
    );
  }


  // Se estiver no fluxo de registro de nova barbearia (SaaS Onboarding)
  // Isolamento total: Não renderiza nada do App principal
  if (isRegisteringBusiness) {
    return (
      <RegistroNegocio
        initialPlan={selectedPlan}
        onBack={() => setIsRegisteringBusiness(false)}
        onComplete={(shopSlug) => {
          setIsRegisteringBusiness(false);
          setSelectedPlan(null);
          setCurrentTenant(shopSlug);
          setBookingStep('dashboard');
          // Update URL without reload
          const newUrl = window.location.pathname + `?shop=${shopSlug}`;
          window.history.replaceState({ path: newUrl }, '', newUrl);
        }}
      />
    );
  }

  if (!currentTenant) {
    return (
      <div className="App">
        {showLogin && (
          <Acesso
            onLogin={handleLogin}
            onClose={() => setShowLogin(false)}
            initialView={loginMode}
          />
        )}
        <PaginaVendas
          onLoginClick={(mode = 'login') => { setLoginMode(mode); setShowLogin(true); }}
          user={user}
          onNavigate={handleNavigate}
          onStartRegistration={handleStartRegistration}
        />
      </div>
    );
  }

  return (
    <div className="App">
      {isSuspended && masterBypass && (
        <div style={{ background: '#ff4444', color: 'white', textAlign: 'center', padding: '10px', fontSize: '0.9rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '1px', zIndex: 10001, position: 'relative' }}>
          ⚠️ MODO MASTER BYPASS ATIVO ⚠️
          <button onClick={() => setMasterBypass(false)} style={{ marginLeft: '20px', background: 'white', color: 'black', border: 'none', padding: '4px 10px', borderRadius: '4px', cursor: 'pointer', fontWeight: 900 }}>SAIR DO BYPASS</button>
        </div>
      )}
      <div className={`global-db-status ${dbStatus.toLowerCase()} ${isSuspended ? 'offline' : ''}`}>
        {isSuspended ? '● SISTEMA BLOQUEADO' : (dbStatus === 'Online' ? '● Sistema Online' : '○ Conectando...')}
      </div>

      {bookingStep !== 'dashboard' && (
        <BarraNavegacao
          user={user}
          onLogout={handleLogout}
          onNavigate={handleNavigate}
          onLoginClick={() => setShowLogin(true)}
          shopName={tenantConfig?.name}
          logoUrl={tenantConfig?.logoUrl}
        />
      )}

      <div className="main-content">
        {showLogin && (
          <Acesso
            onLogin={handleLogin}
            onClose={() => setShowLogin(false)}
            initialView={user && !user.isProfileComplete ? 'collect_whatsapp' : loginMode}
          />
        )}
        {bookingStep === 'home' && (
          <>
            <Banner lastApp={lastApp} onExpressBooking={handleExpressBooking} shopName={tenantConfig?.name} logoUrl={tenantConfig?.logoUrl} />
            <Barbeiros onSelectBarber={handleSelectBarber} barbers={barbers} error={dbError} loading={!isBarbersLoaded} />
            <Avaliacoes appointments={appointments} />
            <Localizacao config={tenantConfig} />
            <Contato config={tenantConfig} />
          </>
        )}
        {bookingStep === 'service' && <AgendamentoServico onSelectServices={handleSelectServices} onBack={handleBack} services={services} />}
        {bookingStep === 'datetime' && <AgendamentoDataHora onConfirm={handleConfirmBooking} onBack={handleBack} selectedBarber={selectedBarber} selectedServices={selectedServices} appointments={user?.isAdmin ? appointments : [...new Map([...appointments, ...systemBlocks].map(item => [item.id, item])).values()]} blockedTimes={blockedTimes} services={services} reschedulingAppId={reschedulingAppId} />}
        {bookingStep === 'dashboard' && <PainelDono globalBroadcast={globalBroadcast} appointments={appointments} onUpdateStatus={handleUpdateStatus} onBack={handleBack} user={user} barbers={barbers} services={services} blockedTimes={blockedTimes} systemBlocks={systemBlocks} currentTenant={currentTenant} config={tenantConfig} />}
        {bookingStep === 'history' && <HistoricoUsuario appointments={user?.isAdmin ? appointments : userAppointments} user={user} onBack={handleBack} onUpdateAppointment={handleUpdateAppointment} onReschedule={handleReschedule} onUpdateStatus={handleUpdateStatus} />}
        {bookingStep === 'success' && <SucessoAgendamento bookingDetails={confirmedBooking} onBackToHome={() => setBookingStep('home')} />}
        {bookingStep === 'profile' && <PainelConfiguracoes user={user} onUpdateProfile={handleUpdateProfile} onBack={handleBack} />}
      </div>
    </div>
  );
}

export default App;
